import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  
  palette: {
    mode: 'dark',
    primary: {
      main: '#03a9f4',
    },
    secondary: {
      main: '#e91e63',
    },
    error: {
      main: red.A400,
    },
  },
  components: {
    
  }
});


export default theme;